import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoIconBorder = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 800 800",
	style: { enableBackground: "new 0 0 800 800" },
	xmlSpace: "preserve",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 800,
			height: 800,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M50,50v700h700V50H50z M650,650H150V150h500V650z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("polygon", {
			points: "600,500 300,500 300,300 500,300 500,400 600,300 600,200 200,200 200,600 600,600 ",
			fill: "currentColor"
		})
	]
});
export default SvgLogoIconBorder;
